// @flow
import React from 'react';
import classNames from 'classnames';
import Button from './Button';
import RangeInput from './RangeInput';
import Storage from '../protocol/Storage';
import { Row } from './layout';

import './LayoutControls.css';
import t from '../i18n/I18n';
import SaveSettings from '../queries/settings/SaveSettings';
import { ThemeSetup } from '../themes/ThemeSetup';
import { getInnerWidth } from '../util/ScreenUtil';
import ToolTip from './AssetPropertyView';
import TootipProperties from '../common/TooltipProperties';

const LIST = 'LIST';
const GRID = 'GRID';

type Layout = 'LIST' | 'GRID' | 'MOSAIC' | 'TREE';

type Props = {
  layout: Layout,
  scale: number,
  defaultScale: string,
  onLayoutChange: Function,
  onScaleChange: Function,
  sliderProps: Object,
  fromCollection: boolean
};

class LayoutControls extends React.Component<Props, {}> {
  static defaultProps = {
    defaultScale: '0.75',
    sliderProps: {
      min: '.5',
      max: '1.25',
      step: 'any'
    },
    fromCollection: false
  };

  onLayoutChange = (layout: Layout) => {
    this.props.onLayoutChange(layout);
  };

  render() {
    const { layout, scale, defaultScale, sliderProps, onScaleChange, fromCollection } = this.props;
    let sliderRangeProps: object = sliderProps;
    if (fromCollection) {
      sliderRangeProps = { min: '.5', max: getInnerWidth() / (580 * 2), step: 'any' };
    }
    return (
      <Row center="V" name="LayoutControls">
        {layout === LIST ? null : (
          <div
            className={classNames('reset-scale', { hide: scale == defaultScale })}
            onClick={() => onScaleChange({ target: { value: defaultScale } })}>
            ({t('RESET')})
          </div>
        )}
        <Row
          center="V"
          style={{ ...styles.sliderWrapper, width: layout === LIST ? 0 : 105, marginLeft: layout === LIST ? 0 : 10 }}>
          {layout === LIST ? null : (
            <ToolTip text={TootipProperties.ZoomInOutSlider}>
              <RangeInput {...sliderRangeProps} height={'21px'} value={scale} onChange={onScaleChange} />
            </ToolTip>
          )}
        </Row>
        <Button
          type="PLAIN"
          icon={layout == LIST ? ThemeSetup.getImageURL('list_view_red.svg') : 'images/list_view_gray.svg'}
          title={t('TOOLTIP_TEXTS.ASSET_LIST_VIEW')}
          onClick={() => this.onLayoutChange(LIST)}
        />
        <Button
          type="PLAIN"
          icon={layout == GRID ? ThemeSetup.getImageURL('grid_view_red.svg') : 'images/grid_view_gray.svg'}
          title={t('TOOLTIP_TEXTS.ASSET_GRID_VIEW')}
          onClick={() => this.onLayoutChange(GRID)}
        />
      </Row>
    );
  }
}

const styles = {
  sliderWrapper: {
    overflow: 'hidden',
    transition: 'width 150ms ease-out',
    height: 18,
    width: 105,
    paddingRight: 5
  }
};

export default LayoutControls;
